import type { ReportRequest } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCreateReport } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCallback } from "react"
import { noticeError } from "src/utils"

export function useSendReport() {
  const createReport = useCreateReport()

  const sendReport = useCallback(
    async (reportRequest: ReportRequest) => {
      try {
        if (!createReport) {
          throw new Error("cannot create report for unauthorized user")
        }

        const axiosResponse = await createReport(reportRequest)
        return axiosResponse
      } catch (e) {
        noticeError(
          e,
          "CreateReport",
          { data: reportRequest },
        )

        throw e
      }
    },

    [createReport],
  )

  return sendReport
}
